<template>
  <div class="tab__main" :style="prop.box_style">
    <div class="tab__div">
      <span class="totolSpace" :class="{ 'platform-g': platform !== 'web' }">
        共{{ totalNum }}个空间
        <i class="el-icon-refresh-right" @click="refresh()"></i>
      </span>
      <el-tabs
        v-model="currentTab"
        @tab-click="handleClick"
        :style="prop.attr.tab_style ? prop.attr.tab_style : ''"
      >
        <el-tab-pane label="全部空间" name="全部空间"></el-tab-pane>
        <el-tab-pane label="我创建的" name="我创建的"></el-tab-pane>
        <el-tab-pane label="我参与的" name="我参与的"></el-tab-pane>
      </el-tabs>
      <!-- 新建空间 -->
      <div v-show="from !== 'openSpaceList' && currentTab !== '我参与的'" class="mg-bt-sm">
        <el-button type="primary" @click="openDialog()">
          <i class="el-icon-plus" style="padding-right: 15px"></i>
          新建空间
        </el-button>
      </div>
      <div v-show="from !== 'openSpaceList' && currentTab === '我参与的'" class="mg-bt-sm" style="height: 32px"></div>
    </div>
    <el-dialog
      :visible="showSpace"
      title="新建空间"
      width="440px"
      @close="closeDialog"
      :close-on-click-modal="false"
      custom-class="space-dialog"
      :append-to-body="true"
    >
      <el-form
        ref="dialogForm"
        :model="dialogInfo"
        label-width="82px"
        label-position="left"
        :rules="rules"
      >
        <el-form-item label="空间名称:" prop="name">
          <el-input
            v-model.trim="dialogInfo.name"
            placeholder="请输入"
            :disabled="dialogType === 'edit'"
            :maxlength="30"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item class="cover" label="封面:" prop="cover">
          <div class="gou-upload">
            <div
              v-if="!shopLogoUrl"
              class="gou-upload-logo"
              @click="() => mutateLogo()"
            >
              <i class="iconfont icon-icon_add" />
              <i class="el-icon-plus"></i>
            </div>
            <div v-else class="gou-reupload-item-image">
              <img id="showLogoImg" :src="shopLogoUrl" alt="" />
              <gou-pick-file
                :filters="imgFilters"
                :multiple="false"
                :max-file-size="2"
                @event-pick-file="(data) => mutateLogo(data.file)"
              >
                <div class="gou-upload-item-image-operate">重新上传</div>
              </gou-pick-file>
            </div>
          </div>
          <span class="img-msg"> 支持2MB以下, jpg/png </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footer">
        <slot name="customFooter">
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            type="primary"
            :loading="confirmLoading"
            @click="confirmDialog"
            >确定</el-button>
        </slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GouPickFile from '@/components/gou/GouPickFile'
import { createTeamSpacesErrorCodeMap } from './errorCodeMap'
export default {
  components: {
    GouPickFile,
  },
  name: 'TabModule',
  props: {
    // 标识在哪个页面使用
    from: {
      type: String,
    },
    prop: {
      type: Object,
    },
    activeName: {
      type: String,
    },
    totalNum: {
      type: Number,
    },
  },
  data() {
    return {
      currentTab: this.activeName || '全部空间',
      scrolltop: null,
      dom: null,
      domobj: {},
      showSpace: false,
      dialogInfo: {},
      dialogForm: {},
      imageUrl: '',
      rules: {
        name: [
          { required: true, message: '请输入30个字内空间名称', trigger: 'change' },
          { validator: this.customValidate, trigger: 'blur' }
        ],
      },
      activeApiCode: '',
      confirmLoading: false,
      dialogType: 'add',
      index: 1,
      dialogImageUrl: '',
      disabled: false,
      scrollTop: '',
      scrollBlock: 0,
      shopLogoUrl: '',
      imgFilters: '.jpg,.png',
    }
  },
  watch: {
    showSpace(val) {
      if (!val) {
        this.$refs.dialogForm.resetFields()
      }
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
    }),
    tabStyle() {
      return function (params) {
        return this.prop.attr.tab_content[params].tab_style || ''
      }
    },
  },
  mounted() {
    // this.onWatchScroll()
    window.addEventListener('scroll', this.rolling)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.rolling)
  },
  methods: {
    rolling() {
      const tabmain = document.querySelector('.tab__main')
      const tabdiv = document.querySelector('.tab__div')
      tabdiv.style.top = 0

      if (!tabmain || !tabdiv) return
      // 滚动过的距离
      this.scrollTop =
        window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      // 当前可视区的高度
      var clientHeight = document.documentElement.clientHeight
      // 滚动条的长度
      var scrollHeight = document.documentElement.scrollHeight
      // 自定义吸顶效果
      if (this.scrollTop > tabmain.offsetTop) {
        tabdiv.style.width = '1200px'
        tabdiv.style.position = 'fixed'
        tabdiv.style['z-index'] = 99
      } else {
        tabdiv.style.position = 'relative'
        tabdiv.style['z-index'] = 0
      }
      // 当this.scrollTop不等于0，且当滚动过的距离+可视区的高度>=滚动条长度时，就相当于滚动到了底部
      if (this.scrollTop && (this.scrollTop + clientHeight >= scrollHeight - this.scrollBlock)) {
        this.index++
        this.scrollBlock += 180
        this.$parent.getTeamSpaces(this.index)
        // console.log(this.scrollTop, clientHeight, scrollHeight, this.scrollBlock)
      }
    },
    // Tab切换
    handleClick() {
      this.index = 1
      this.scrollBlock = 0
      this.$parent.handleChildMessage(this.currentTab)
    },
    // 新建-重名校验
    customValidate(rule, value, callback) {
      let errorFound = false
      for (const key in createTeamSpacesErrorCodeMap) {
        if (Object.prototype.hasOwnProperty.call(createTeamSpacesErrorCodeMap, key)) {
          if (this.activeApiCode === key) {
            this.activeApiCode = ''
            callback(new Error(createTeamSpacesErrorCodeMap[key]))
            errorFound = true
            break
          }
        }
      }
      if (!errorFound) {
        callback()
      }
    },
    // 图片上传
    async mutateLogo(file) {
      if (file === undefined) {
        file = await this.$file.pickFile({
          filters: this.imgFilters,
        })
        await this.mutateLogo(file)
      } else {
        this.dialogInfo.cover = file
        // 创建 一个FileReader对象
        var reader = new FileReader()
        console.log(reader)
        reader.onload = (e) => {
          console.log(e)
          this.shopLogoUrl = e.target.result
        }
        // 读取文件作为URL可访问地址
        reader.readAsDataURL(file)
      }
    },
    // 新建
    openDialog() {
      this.dialogInfo = {}
      this.shopLogoUrl = ''
      this.showSpace = true
    },
    closeDialog() {
      this.showSpace = false
    },
    // 刷新
    refresh() {
      this.index = 1
      this.scrollBlock = 0
      // 刷新空间列表
      this.$emit('updateTeamSpaces')
    },
    // 新建空间
    confirmDialog() {
      this.confirmLoading = true
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          const formData = new FormData()
          formData.append('name', this.dialogInfo.name)
          formData.append('cover', this.dialogInfo.cover)
          this.$api.space.addTeamSpaces(formData).then((res) => {
            if (res === true) {
              this.showSpace = false
              this.$message.success(`新建成功`)
              this.index = 1
              this.scrollBlock = 0
              this.activeApiCode = ''
              // 刷新空间列表
              this.$emit('updateTeamSpaces', 'add')
            }
          }).catch((err) => {
            this.activeApiCode = err.code
            this.$refs.dialogForm.validateField('name')
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.tab__main {
  width: 1200px !important;
  .tab__div {
    width: 100%;
    position: relative;
    background-color: #fff;
    .tab__list {
      display: flex;
      .tab__item {
        flex: 1;
        font-size: 32px;
      }
      .tab__item-current {
        font-weight: 700;
      }
    }
    .totolSpace {
      color: #495f70 !important;
      font-size: 12px;
      position: absolute;
      right: 0;
      top: 10px;
      z-index: 10;
    }
  }
}
.el-icon-refresh-right {
  color: #009ee1;
  padding-left: 6px;
  cursor: pointer;
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
  border-bottom: 1px solid #d2d9e3 !important;
}
/deep/ .el-tabs__item {
  font-weight: unset !important;
  color: #495f70 !important;
}
/deep/ .el-tabs__item.is-active {
  color: #009ee1 !important;
}
.mg-bt-sm {
  text-align: left;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
/deep/ .el-form-item__label:not(required)::before {
  content: "*";
  color: transparent;
  margin-right: 4px;
}
.cover > .el-form-item__label {
  padding-left: 10px !important;
}
.gou-upload {
  display: flex;
  align-items: flex-end;
  .gou-upload-item-image {
    width: 300px;
    height: 156px;
    background: rgba(225, 225, 235, 1);
    margin-left: 32px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .gou-upload-item-image-operate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      background: rgba(35, 40, 50, 1);
      opacity: 0.5;
      text-align: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      padding: 4px 0;
    }
  }
  .gou-reupload-item-image {
    width: 300px;
    height: 156px;
    background: rgba(225, 225, 235, 1);
    position: relative;
    text-align: center;
    & > img {
      width: 300px;
      height: 156px;
    }
    .gou-upload-item-image-operate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      background: rgba(35, 40, 50, 1);
      opacity: 0.5;
      text-align: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      padding: 4px 0;
      & :hover {
        color: #39e9db;
      }
    }
  }
  .gou-upload-logo {
    border: 1px dashed #d2d9e3;
    cursor: pointer;
    width: 300px;
    height: 156px;
    background-color: #fafafa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    span {
      line-height: 10px;
    }
    .icon-icon_add {
      font-size: 12px;
      &::before {
        border: 2px solid rgba(76, 84, 114, 1);
        border-radius: 50%;
        padding: 2px;
      }
    }
  }
  .gou-upload-tips {
    margin-left: 16px;
  }
}
.img-msg {
  font-size: 12px;
  color: #495f70;
}
</style>
